import React, { useMemo, useState } from 'react';
import { Box, Dialog, IconButton, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

interface Props {
    imagesUrls: string[];
}

// ShowNoteImages adapted to Material-UI v4 without external lightbox dependency
const ShowNoteImages: React.FC<Props> = ({ imagesUrls }) => {
    const [open, setOpen] = useState<boolean>(false);
    const [imageIndex, setImageIndex] = useState<number>(0);

    const firstTwoImages = useMemo(() => imagesUrls.slice(0, 2), [imagesUrls]);
    const firstThreeImages = useMemo(() => imagesUrls.slice(0, 3), [imagesUrls]);
    const hasMoreThanThreeImages = useMemo(() => imagesUrls.length > 3, [imagesUrls]);

    if (!imagesUrls || imagesUrls.length === 0) return null;

    const handleOpen = (index: number) => {
        setOpen(true);
        setImageIndex(index);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleNext = () => {
        setImageIndex((prev) => (prev + 1) % imagesUrls.length);
    };

    const handlePrev = () => {
        setImageIndex((prev) => (prev + imagesUrls.length - 1) % imagesUrls.length);
    };

    const gridImages = hasMoreThanThreeImages ? firstTwoImages : firstThreeImages;

    return (
        <Box
            style={{ display: 'grid', gap: 8, gridTemplateColumns: 'repeat(3, 1fr)', paddingLeft: 8, paddingRight: 8 }}
        >
            {gridImages.map((imageUrl, index) => (
                <Box
                    key={`${imageUrl}-${index}`}
                    onClick={() => handleOpen(index)}
                    style={{
                        display: 'grid',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        borderRadius: 4,
                        cursor: 'pointer',
                    }}
                >
                    <img
                        src={imageUrl}
                        alt={`Note attachment ${index + 1}`}
                        style={{ width: 'auto', maxWidth: '100%', height: 'auto', maxHeight: 150, borderRadius: 4 }}
                    />
                </Box>
            ))}

            {hasMoreThanThreeImages && (
                <Box style={{ alignSelf: 'center', justifySelf: 'center' }}>
                    <Typography style={{ fontSize: 30, opacity: 0.54, color: 'black' }}>
                        +{imagesUrls.length - 2}
                    </Typography>
                </Box>
            )}

            <Dialog open={open} onClose={handleClose} maxWidth='md'>
                <Box style={{ position: 'relative', background: 'black' }}>
                    <IconButton
                        onClick={handleClose}
                        style={{ position: 'absolute', top: 8, right: 8, color: 'white', zIndex: 2 }}
                    >
                        <CloseIcon />
                    </IconButton>

                    <IconButton
                        onClick={handlePrev}
                        style={{ position: 'absolute', top: '50%', left: 8, color: 'white', zIndex: 2 }}
                    >
                        <ChevronLeftIcon />
                    </IconButton>

                    <IconButton
                        onClick={handleNext}
                        style={{ position: 'absolute', top: '50%', right: 8, color: 'white', zIndex: 2 }}
                    >
                        <ChevronRightIcon />
                    </IconButton>

                    <Box style={{ display: 'grid', placeItems: 'center', padding: 16 }}>
                        <img
                            src={imagesUrls[imageIndex]}
                            alt={`Note attachment ${imageIndex + 1}`}
                            style={{ maxWidth: '80vw', maxHeight: '80vh' }}
                        />
                    </Box>
                </Box>
            </Dialog>
        </Box>
    );
};

export default ShowNoteImages;
